import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import moment from 'moment'
import ContentLoader from 'react-content-loader'
import colors from '../../../../configuration/colors'
import FlexAlignCenter from '../../../styled/FlexAlignCenter'
import _Checkmark from '../../../../static/images/Skills/checkmark.svg'
import _Flag from '../../../../static/images/mycourses/check-in_flag.svg'
import { CoreChoiceMarker } from '../styles'
import { Caption1, Caption4 } from '../../../styled/typography/typography'
import TargetDateIcon from '../../../mini/LevelQuest/TargetDateIcon/TargetDateIcon'
import KeepWorkingSvg from '../../../../static/images/icons/icon_keep_working_white.svg'
import MarkdownRenderer from 'react-markdown-renderer'
import useLexicon from '../../../../hooks/useLexicon'

export const KeepWorkingIcon = styled.img.attrs({
  src: KeepWorkingSvg
})`
  height: 14px;
  width: 12px;
  margin-right: 6px;
`

const TooltipWrapper = styled.div`
  width: 303px;

  .__react_component_tooltip.place-top {
    &:before {
      display: none !important;
    }

    .place-top {
      &:after {
        display: none !important;
        border-color: ${props => props.theme.tooltipBackground} !important;
      }
    }

    .place-top {
      &:before {
        display: none !important;
        border-color: ${props => props.theme.tooltipBackground} !important;
      }


    }
  }
`

const TooltipBody = styled.div`
  background: ${props => props.theme.tooltipBackground} !important;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 12px 17px;
  word-wrap: break-word;
  white-space: normal;

  .h6 {
    color: ${props => props.theme.h6}
  }
`

const BannerTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 17px;
  background: #${props => props.courseColor};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  img {
    border: none !important;
    border-radius: 0 !important;
  }

  ${({ awaitingFeedback }) =>
    awaitingFeedback &&
    `
    background: ${colors.victoria};
    height: 22px;
  `}

  ${props =>
    props.feedbackContinue &&
    `
    background: ${colors.jade};
    height: 22px;
  `}


  ${props =>
    props.feedbackKeepWorking &&
    `
    background: ${colors.zest};
    height: 22px;
  `}

  ${({ questComplete }) =>
    questComplete &&
    `
    background: #444440;
    height: 22px;
  `}
`

const Checkmark = styled.img.attrs({
  src: _Checkmark
})`
  height: 9px;
  width: 11px;
  margin-right: 5px;
`

const Flag = styled.img.attrs({
  src: _Flag
})`
  height: 10px;
  width: 8px;
  margin-right: 8px;
`

const QuestTooltip = ({
  quest,
  unstarted,
  awaitingFeedback,
  feedbackKeepWorking,
  feedbackContinue,
  questComplete,
  core,
  progress,
  courseColor,
  targetDate,
  isLoading,
  isActivityCourse
}) => {
  const lexicon = useLexicon()

  const getBannerText = (
    questComplete,
    progress,
    awaitingFeedback,
    feedbackContinue,
    feedbackKeepWorking,
    isActivityCourse
  ) => {
    let retVal = null

    if (questComplete) {
      retVal = (
        <React.Fragment>
          <Caption4 white>
            <Checkmark />
            { !isActivityCourse ? lexicon.quest : lexicon.activity } Complete:
          </Caption4>
          <Caption1 white>
            {moment.unix(progress.completed_at).format('D MMM YYYY')}
          </Caption1>
        </React.Fragment>
      )
    } else if (awaitingFeedback) {
      retVal = (
        <Caption4 white>
          <Flag />
          Waiting for {lexicon.mentor} feedback.
        </Caption4>
      )
    } else if (feedbackKeepWorking) {
      retVal = (
        <Caption4
          white
          style={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <KeepWorkingIcon />
          Keep working on this {lexicon.activity}.
        </Caption4>
      )
    } else if (feedbackContinue) {
      retVal = <Caption4 white>&#128077; Complete {lexicon.activity}.</Caption4>
    }
    return retVal
  }

  return (
    <TooltipWrapper>
      <BannerTop
        questComplete={questComplete}
        awaitingFeedback={awaitingFeedback}
        feedbackContinue={feedbackContinue}
        feedbackKeepWorking={feedbackKeepWorking}
        courseColor={courseColor}
      >
        {getBannerText(
          questComplete,
          progress,
          awaitingFeedback,
          feedbackContinue,
          feedbackKeepWorking,
          isActivityCourse
        )}
      </BannerTop>
      {isLoading ? (
        <div style={{ padding: '5px 17px' }}>
          <ContentLoader
            width={250}
            height={80}
            speed={2}
            primaryColor="#F1F1F1"
            secondaryColor="#FBFBFB"
          >
            <rect x="0" y="15" rx="0" ry="0" width="295" height="10" />
            <rect x="0" y="35" rx="0" ry="0" width="295" height="10" />
            <rect x="0" y="55" rx="0" ry="0" width="200" height="10" />
          </ContentLoader>
        </div>
      ) : (
        <TooltipBody>
          <div className="h6" style={{ paddingBottom: '5px' }}>
            {quest.name}
          </div>
          <Caption1 className="markdown" style={{ paddingBottom: '11px' }}>
            <MarkdownRenderer
              markdown={quest.learner_goal}
              options={{
                linkTarget: '_blank'
              }}
            />
          </Caption1>
          <FlexAlignCenter style={{ justifyContent: 'space-between' }}>
            <FlexAlignCenter style={{ justifyContent: 'space-around' }}>
              {!isActivityCourse && (
                <CoreChoiceMarker>{ core ? lexicon.core : lexicon.choice }</CoreChoiceMarker>
              )}
              {targetDate && !questComplete ? (
                <TargetDateIcon targetDate={targetDate} shouldShowDate={true} />
              ) : (
                ''
              )}
            </FlexAlignCenter>
            {!isActivityCourse && !unstarted && !questComplete && (
              <div className="caption4">
                {`${lexicon.activity} ${progress.current_activity_metadata.number} of ${progress.quest_activities_count}`}
              </div>
            )}
          </FlexAlignCenter>
        </TooltipBody>
      )}
    </TooltipWrapper>
  )
}

QuestTooltip.propTypes = {
  quest: PropTypes.object.isRequired,
  unstarted: PropTypes.bool.isRequired,
  awaitingFeedback: PropTypes.bool,
  feedbackKeepWorking: PropTypes.bool,
  feedbackContinue: PropTypes.bool,
  questComplete: PropTypes.bool,
  core: PropTypes.bool,
  progress: PropTypes.object,
  courseColor: PropTypes.string,
  targetDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isComplete: PropTypes.bool
}

export default QuestTooltip
